import { createSlice } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';
const templateSlice = createSlice({
    name: 'template',
    initialState: {},
    reducers: {
        setTemplate: (state, action) => {
            state = cloneDeep(action.payload);
            return state;
        },
    },
});
export const {
    setTemplate,
} = templateSlice.actions;
export default templateSlice.reducer;
